import { render, staticRenderFns } from "./MaterialsOrderUnitToggle.vue?vue&type=template&id=0d28bb75&scoped=true"
import script from "./MaterialsOrderUnitToggle.vue?vue&type=script&lang=js"
export * from "./MaterialsOrderUnitToggle.vue?vue&type=script&lang=js"
import style0 from "./MaterialsOrderUnitToggle.vue?vue&type=style&index=0&id=0d28bb75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28bb75",
  null
  
)

export default component.exports